type ExecutionOutputValue = {
  label: string;
  value: string;
};

const appendOutputValue = (
  outputValues: ExecutionOutputValue[],
  label: string,
  value?: string | null,
): void => {
  if (typeof value === 'string' && value.trim().length > 0) {
    outputValues.push({ label, value });
  }
};

export const buildExecutionOutputValues = (
  systemOut?: string | null,
  systemErr?: string | null,
): ExecutionOutputValue[] => {
  const outputValues: ExecutionOutputValue[] = [];
  appendOutputValue(outputValues, 'System Out', systemOut);
  appendOutputValue(outputValues, 'System Err', systemErr);
  return outputValues;
};

export const buildTestRunOutputValues = ({
  failureStack,
  systemOut,
  systemErr,
}: {
  failureStack?: string | null;
  systemOut?: string | null;
  systemErr?: string | null;
}): ExecutionOutputValue[] => {
  const outputValues: ExecutionOutputValue[] = [];
  appendOutputValue(outputValues, '', failureStack);
  appendOutputValue(outputValues, 'System Out', systemOut);
  appendOutputValue(outputValues, 'System Err', systemErr);
  return outputValues;
};

export const formatExecutionOutputValue = (outputValues: ExecutionOutputValue[]): string => {
  if (outputValues.length === 0) {
    return '-';
  }

  return outputValues
    .map((item) => (item.label.length > 0 ? `${item.label}:\n${item.value}` : item.value))
    .join('\n\n');
};

export type { ExecutionOutputValue };
